export const SET_IS_FILE_UPLOADING = "SET_IS_FILE_UPLOADING";

export function setIsFileUploading(isUploading) {
   return {
      type: SET_IS_FILE_UPLOADING,
      isUploading
   };
}